export const TYPES = {
    YCA: 'yca',
    YCP: 'ycp',
    IMAGES: 'images',
};
